module.exports = {"TXTWCL_Runner":{"id":"TXTWCL_Runner","defaultMessage":"Partant"}}